import { useEffect, useState } from "react";
import { ScreenProps } from "../../App";
import { useMotivationalQuoteQuery } from "./queries/useMotivationalQuoteQuery";
import "./styles/MotivationalQuoteScreen.sass";
import { usePreloadImages } from "../../hooks/usePreloadImages";

const MotivationalQuoteScreen: React.FC<ScreenProps> = ({ isActive }) => {
  const { data, refetch, isLoading, isError } = useMotivationalQuoteQuery();

  const [randomImage, setRandomImage] = useState<string | undefined>(undefined);

  usePreloadImages(data?.images ?? []);

  useEffect(() => {
    if (!isActive) {
      refetch();
    }
    if (data?.images?.length) {
      setRandomImage(
        data.images[Math.floor(Math.random() * data.images.length)],
      );
    } else {
      setRandomImage(undefined);
    }
  }, [isActive, refetch, data]);

  if (isLoading) {
    return (
      <div className="motivational-quote-screen">
        <div className="h1">
          <h1>Spruch der Woche</h1>
        </div>
        <div
          style={{ textAlign: "center", fontSize: "2rem", color: "#00ffce" }}
        >
          Laden...
        </div>
      </div>
    );
  }

  if (isError) {
    return (
      <div className="motivational-quote-screen">
        <div className="h1">
          <h1>Spruch der Woche</h1>
        </div>
        <div
          style={{ textAlign: "center", fontSize: "2rem", color: "#ff0099" }}
        >
          Fehler beim Laden der Daten
        </div>
      </div>
    );
  }

  return (
    <div className="motivational-quote-screen">
      <div className="h1">
        <h1>Spruch der Woche</h1>
      </div>
      {randomImage && (
        <img className="quote-image" src={randomImage} alt="Motivational" />
      )}
      {data?.content && <p className="quote-content">{data.content}</p>}
    </div>
  );
};

export default MotivationalQuoteScreen;
